import { Tag, Td } from "@chakra-ui/react";
import moment from "moment";
import { useTranslation } from "react-i18next";
import { FiRotateCcw } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { ContractStateDto, useListMyRecentlyViewedContractsQuery } from "../../../autogen/bff-api";
import { momentLocaleFor } from "../../../common/formatting/i18nFormatters";
import { urls } from "../../../urls";
import { ContractStatusTag } from "../../contracts/edit/ContractStatusTag";
import { HomePanel } from "./HomePanel";
import { MutedCell, PanelRow, PanelTable, TitleCell } from "./PanelTable";

const DISPLAY_LIMIT = 5;

export const RecentContractsPanel = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const momentLocale = momentLocaleFor(i18n.language);

  const { data, isLoading, isError } = useListMyRecentlyViewedContractsQuery({ limit: DISPLAY_LIMIT });
  const contracts = data?.contracts ?? [];

  return (
    <HomePanel
      titleKey="Recently opened contracts"
      icon={FiRotateCcw}
      seeAllTo={urls.app.contracts.viewAll}
      isLoading={isLoading}
      isError={isError}
      isEmpty={contracts.length === 0}
      emptyKey="Open a contract and it shows up here"
    >
      <PanelTable headers={[t("Title"), t("Status"), t("Last opened")]}>
        {contracts.map((contract) => (
          <PanelRow key={contract.id} onClick={() => navigate(urls.app.contracts.view.go(contract.id))}>
            <TitleCell title={contract.title || t("Untitled")} subtitle={contract.counterpartyName ?? undefined} />
            <Td>
              {contract.status ? (
                <ContractStatusTag status={contract.status} size="sm" />
              ) : (
                <Tag variant="outline" colorScheme="gray" size="sm">
                  {contract.state === ContractStateDto.Draft ? t("Draft") : t("Unknown")}
                </Tag>
              )}
            </Td>
            <MutedCell>{moment(contract.viewedAt).locale(momentLocale).fromNow()}</MutedCell>
          </PanelRow>
        ))}
      </PanelTable>
    </HomePanel>
  );
};
